import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function WhatItIsNot() {
  return <section className="py-20 md:py-28 bg-[#0A0A0A] text-[#FAF7F2]" data-id="element-317">
      <div className="max-w-3xl mx-auto px-4" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-319">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A]" data-id="element-320">
            💎 18 MÉTODOS NO ES:
          </h2>
        </motion.div>

        {/* What it's NOT */}
        <div className="space-y-4 mb-10" data-id="element-321">
          <motion.div className="flex items-center gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} data-id="element-322">
            <div className="bg-[#B91C1C]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-323">
              <XIcon className="w-4 h-4 text-[#B91C1C]" data-id="element-324" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/70" data-id="element-325">
              Romanticismo vacío
            </p>
          </motion.div>

          <motion.div className="flex items-center gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} data-id="element-326">
            <div className="bg-[#B91C1C]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-327">
              <XIcon className="w-4 h-4 text-[#B91C1C]" data-id="element-328" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/70" data-id="element-329">
              Consejos superficiales
            </p>
          </motion.div>

          <motion.div className="flex items-center gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.3
        }} data-id="element-330">
            <div className="bg-[#B91C1C]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-331">
              <XIcon className="w-4 h-4 text-[#B91C1C]" data-id="element-332" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/70" data-id="element-333">"Hablen más"</p>
          </motion.div>
        </div>

        {/* What it IS */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mb-12" data-id="element-334">
          <p className="text-xl md:text-2xl text-[#FAF7F2] font-medium leading-relaxed" data-id="element-335">
            Es dirección íntima. Es estructura. Es activación real del vínculo.
          </p>
        </motion.div>

        <div className="w-full h-px bg-[#C5A55A]/20 mb-10" data-id="element-336"></div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="mb-8" data-id="element-337">
          <h3 className="text-xl md:text-2xl font-serif text-[#FAF7F2] mb-8" data-id="element-338">
            En 90 minutos aprenderás:
          </h3>
        </motion.div>

        <div className="space-y-5" data-id="element-339">
          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} data-id="element-340">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-341">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-342" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-343">
              Cómo reactivar deseo aunque haya rutina
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} data-id="element-344">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-345">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-346" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-347">
              Cómo romper el automático en la intimidad
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.3
        }} data-id="element-348">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-349">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-350" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-351">
              Cómo evitar que el amor se vuelva fraternal
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.4
        }} data-id="element-352">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-353">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-354" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-355">
              Cómo volver a sentir atracción dentro de tu propio matrimonio
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.5
        }} data-id="element-356">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-357">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-358" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-359">
              Cómo rescatar conexión antes de que aparezca distancia real
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}